// @flow
import React, {Fragment, PureComponent, type ComponentType} from 'react';
import './withSkipToContentMenu.less';
import classnames from 'classnames';
import {FormattedMessage} from 'react-intl';

const MENU_ITEMS = [
    {
        key: '0',
        hrefId: 'skipToSiteWideNavigation',
        destContainer: 'site-header-nav',
        label: 'Skip to site-wide navigation'
    },
    {
        key: '1',
        hrefId: 'skipToSearchCriteria',
        destContainer: 'SearchBar',
        label: 'Skip to search criteria'
    },
    {
        key: '2',
        hrefId: 'skipToSearchFilters',
        destContainer: 'FilterBar',
        label: 'Skip to filters'
    },
    {
        key: '3',
        hrefId: 'skipToSearchResults',
        destContainer: 'Results',
        label: 'Skip to search results'
    },
    {
        key: '4',
        hrefId: 'skipToSearchResultsPagination',
        destContainer: 'HAPager',
        label: 'Skip to search results pagination'
    }
];

type State = {
    visible: boolean
};

export default function withSkipToContentMenu<OwnProps: {}>(
    WrappedComponent: ComponentType<$Supertype<OwnProps>>
): ComponentType<OwnProps> {
    return class SkipToContentMenu extends PureComponent<OwnProps, State> {
        timeoutValue: any;

        constructor(props: OwnProps) {
            super(props);

            this.state = {
                visible: false
            };
        }

        handleOnFocus = () => {
            clearTimeout(this.timeoutValue);
            this.setState({
                visible: true
            });
        };

        handleOnBlur = () => {
            this.timeoutValue = setTimeout(() => {
                this.setState({
                    visible: false
                });
            }, 0);
        };

        handleOnClick = (event) => {
            event.preventDefault();
            const destContainer = event.currentTarget.getAttribute(
                'data-destination-container'
            );
            const element = window.document.querySelector(`.${destContainer}`);
            const focusables = element.querySelectorAll(
                'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            focusables[0].focus();
        };

        buildMenuItems = () => {
            return MENU_ITEMS.map((menuItem) => {
                const href = `#${menuItem.hrefId}`;
                return (
                    <a
                        key={menuItem.key}
                        href={href}
                        role="menuitem"
                        data-destination-container={menuItem.destContainer}
                        onClick={this.handleOnClick}
                    >
                        <FormattedMessage
                            defaultMessage={menuItem.label}
                            id={menuItem.hrefId}
                        />
                    </a>
                );
            });
        };

        render() {
            const menuClassNames = classnames(
                'SkipToContentMenu',
                this.state.visible
                    ? 'SkipToContentMenu--visible'
                    : 'SkipToContentMenu--invisible'
            );

            return (
                <Fragment>
                    <div
                        className={menuClassNames}
                        aria-label="Skip to content"
                        onFocus={this.handleOnFocus}
                        onBlur={this.handleOnBlur}
                        role="menu"
                    >
                        {this.buildMenuItems()}
                    </div>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
}
